<ng-container *ngIf="datos.opcion == 'detalle'">
  <h2 mat-dialog-title>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_DETALL_PREG'|translate}}</h2>
  <mat-dialog-content class="mat-typography">
    <div fxLayout="column" fxLayoutAlign="start stretch">
      <ng-container *ngIf="datos.modoUsuario">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <mat-form-field class="mt-20" fxFlex>
            <mat-label>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_LAB_TEX_PREG'|translate}}</mat-label>
            <ng-container *ngFor="let idioma of datos.pregunta.questionLanguage;">
              <ng-container *ngIf="idioma.lang == datos.idiomaNative">
                <textarea matInput class="fwb" placeholder="{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.PLACE_HOL_TEX_PREG'|translate}}" [(ngModel)]="idioma.question" (blur)="datos.pregunta.typeAdd != 2 && datos.pregunta.typeAdd != 6 ? datos.pregunta.typeAdd = 4 : true" [disabled]="!edicionPregunta"></textarea>
              </ng-container>
            </ng-container>
          </mat-form-field>
          <button mat-mini-fab *ngIf="!edicionPregunta && datos.validationUser" (click)="edicionPregunta = !edicionPregunta" class="ml-20" [ngClass]="{'botEdit':datos.pregunta.edit}" matTooltip="{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_TOOL_EDIT_PREG'|translate}}" [disabled]="!datos.configTemplate.editables || !datos.pregunta.edit || datos.pasoCompleto">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-mini-fab *ngIf="edicionPregunta" (click)="edicionPregunta = !edicionPregunta" class="ml-20" color="primary" matTooltip="{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_TOOL_EDIT_PREG'|translate}}">
            <mat-icon>done</mat-icon>
          </button>
        </div>
        <mat-form-field appearance="outline" *ngIf="datos.answerType.tipoSeccion == 4" fxFlex>
          <mat-label>Escriba una descripción corta para la nueva pregunta</mat-label>
          <ng-container *ngFor="let idioma of datos.pregunta.questionLanguage;">
            <ng-container *ngIf="idioma.lang == datos.idiomaNative">
              <textarea matInput class="fwb" [(ngModel)]="idioma.descritionShort" (blur)="datos.pregunta.typeAdd != 2 && datos.pregunta.typeAdd != 6 ? datos.pregunta.typeAdd = 4 : true" [disabled]="!edicionPregunta"></textarea>
            </ng-container>
          </ng-container>
        </mat-form-field>

        <ng-container *ngIf="datos.configTemplate.secEspeciales == true">
          <ng-container >
            <mat-divider class="mt-20 mb-20"></mat-divider>
            <p><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_TIP_FORM'|translate}}</em></p>
            <mat-radio-group [(ngModel)]="datos.pregunta.typeCustom">
              <div fxLayout="row" fxLayoutAlign="space-around center">
                <mat-radio-button *ngFor="let tipo of tipoEspecial" [value]="tipo.tipo">{{'CERTIFICARV3.CATALOGOS.PREG_ESPECI.' + tipo.tipo | translate}}</mat-radio-button>
              </div>
            </mat-radio-group>
          </ng-container>
          <ng-container *ngIf="datos.pregunta.typeCustom == 2">
            <mat-divider class="mt-20 mb-20"></mat-divider>
            <p><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_PREG_ESP_FLD'|translate}}</em></p>
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_PREG_ESP_HNT'|translate}}</mat-label>
              <textarea matInput class="fwb" [(ngModel)]="datos.pregunta.key"></textarea>
            </mat-form-field>
          </ng-container>
        </ng-container>

        <mat-divider class="mb-20"></mat-divider>
        <ng-container *ngIf="datos.answerType.tipoPregunta == 4">
          <ng-container *ngIf="datos.pregunta.demographicId != 0; else sinDemografico">
            <ng-container *ngFor="let demografico of datos.catalogoDemograficos;let i = index;">
              <ng-container *ngIf="demografico.demographicId == datos.pregunta.demographicId">
                <ng-container *ngFor="let langDemog of demografico.languages;let j = index;">
                  <h3 *ngIf="langDemog.lang == datos.idiomaNative">Tipo de demográfico: <em>{{langDemog.key}}</em></h3>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
          <ng-template #sinDemografico>
            <h3>No se seleccionó el tipo de demográfico para esta pregunta</h3>
          </ng-template>
          <mat-divider class="mb-20"></mat-divider>
        </ng-container>
        <mat-card>
          <mat-card-header>
            <mat-card-subtitle>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_CARD_OPC_RESP'|translate}}</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <mat-list class="listaPreguntas" [id]="'lista' + idxSecc" cdkDropList [cdkDropListData]="datos.pregunta.answers" [cdkDropListConnectedTo]="listasPreguntas" (cdkDropListDropped)="dropPregunta($event)">
              <!-- <mat-list-item class="pregunta" [ngClass]="{'noEdit':!respuesta.banderas.editable, 'obligatoria':!respuesta.banderas.eliminable, 'obNoEdit':!respuesta.banderas.eliminable && !respuesta.banderas.editable}" cdkDrag *ngFor="let respuesta of datos.pregunta.answers; last as last; let idxResp = index;"> -->
              <mat-list-item class="pregunta" cdkDrag [cdkDragDisabled]="!datos.configTemplate.editables || !datos.pregunta.edit" *ngFor="let respuesta of datos.pregunta.answers; last as last; let idxResp = index;">
                <div class="infoPregunta" fxLayout="row" fxLayoutAlign="space-between center">
                  <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                  <button *ngIf="datos.configTemplate.editables && datos.pregunta.edit && !datos.pasoCompleto" mat-icon-button class="mr-20" cdkDragHandle>
                    <mat-icon>menu</mat-icon>
                  </button>
                  <div fxFlex>
                    <!-- {{respuesta.versiones[respuesta.versionActual].respuesta}} -->
                    <ng-container *ngFor="let idioma of respuesta.answerLanguage;">
                      <ng-container *ngIf="idioma.lang == datos.idiomaNative">
                        {{idioma.tag}}
                      </ng-container>
                    </ng-container>
                  </div>
                  <div class="accionesPregunta" *ngIf="datos.configTemplate.editables && datos.pregunta.edit && !datos.pasoCompleto">
                    <button *ngIf="respuesta.edit" (click)="editaRespuesta(respuesta,idxResp,datos.modoUsuario)" mat-mini-fab class="botEdit mr-10" matTooltip="{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_TOOL_EDIT_RESP'|translate}}">
                    <!-- <button (click)="editaRespuesta(respuesta,idxResp,datos.modoUsuario)" mat-mini-fab class="botEdit mr-10" matTooltip="{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_TOOL_EDIT_RESP'|translate}}"> -->
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button *ngIf="respuesta.delete && datos.pregunta.answers.length > 2 && datos.validationUser" (click)="borraRespuesta(idxResp)" mat-mini-fab color="primary" class="mr-20" matTooltip="{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_TOOL_DELET_RESP'|translate}}">
                    <!-- <button *ngIf="datos.pregunta.answers.length > 2" (click)="borraRespuesta(idxResp)" mat-mini-fab color="primary" class="mr-20" matTooltip="{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_TOOL_DELET_RESP'|translate}}"> -->
                      <mat-icon>delete_forever</mat-icon>
                    </button>
                  </div>
                </div>
                <mat-divider *ngIf="!last"></mat-divider>
              </mat-list-item>
            </mat-list>
          </mat-card-content>
          <mat-card-actions>
            <div fxLayout="row" fxLayoutAlign="center center" *ngIf="datos.configTemplate.editables && datos.pregunta.edit && !datos.pasoCompleto">
              <p class="pr-20">{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_AGRE_OPCI_RESP'|translate}}</p>
              <button mat-mini-fab color="primary" aria-label="agregaPreg" (click)="agregaRespuesta()">
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </mat-card-actions>
        </mat-card>
      </ng-container>

      <ng-container *ngIf="!datos.modoUsuario">
        <ng-container *ngIf="datos.pregunta.typeAdd == 0 || datos.pregunta.typeAdd == 1 || datos.pregunta.typeAdd == 5">
          <div class="mt-20" fxLayout="row" fxLayoutAlign="space-between center" *ngIf="preguntaRecuperada">
            <mat-form-field class="w90" fxFlex>
              <mat-label>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_SELEC_VERSI_PREG'|translate}}</mat-label>

              <ng-container *ngFor="let idioma of datos.pregunta.questionLanguage;">
                <ng-container *ngIf="idioma.lang == datos.idiomaNative">
                  <mat-select [value]="idioma.question" [disabled]="datos.pasoCompleto">
                    <ng-container *ngFor="let pregCatVers of datos.pregCat.textVersions;let j = index;">
                      <ng-container *ngFor="let langPregCatVers of pregCatVers.questionLanguage; let k = index;">
                        <ng-container *ngIf="langPregCatVers.lang == datos.idiomaNative">
                          <mat-option [value]="langPregCatVers.question" (click)="cambiaVersionPreguntaTemplate(datos.pregunta,idxSecc,idxPreg,j)">
                            {{langPregCatVers.question}}
                          </mat-option>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </mat-select>
                </ng-container>
              </ng-container>

            </mat-form-field>
            <button mat-mini-fab *ngIf="!datos.pasoCompleto && datos.validationUser" (click)="editaPreguntaTemplate(datos.pregunta,idxSecc,idxPreg)" class="botEdit ml-20" matTooltip="{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_TOOL_EDIT_PREG'|translate}}">
              <mat-icon>edit</mat-icon>
            </button>
          </div>
        </ng-container>
        <ng-container *ngIf="datos.pregunta.typeAdd == 2 || datos.pregunta.typeAdd == 3 || datos.pregunta.typeAdd == 4 || datos.pregunta.typeAdd == 6">
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <mat-form-field class="mt-20" appearance="outline" fxFlex>
              <mat-label>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_LAB_TEX_PREG'|translate}}</mat-label>
              <ng-container *ngFor="let idioma of datos.pregunta.questionLanguage;">
                <ng-container *ngIf="idioma.lang == datos.idiomaNative">
                  <textarea matInput class="fwb" placeholder="{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.PLACE_HOL_TEX_PREG'|translate}}" [(ngModel)]="idioma.question" [disabled]="!datos.pregunta.editarPregunta  || datos.pasoCompleto"></textarea>
                </ng-container>
              </ng-container>
            </mat-form-field>
            <button mat-mini-fab *ngIf="!datos.pregunta.editarPregunta && datos.validationUser" (click)="datos.pregunta.editarPregunta = !datos.pregunta.editarPregunta" class="botEdit ml-20" matTooltip="{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_TOOL_EDIT_PREG'|translate}}">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-mini-fab *ngIf="datos.pregunta.editarPregunta" (click)="datos.pregunta.editarPregunta = !datos.pregunta.editarPregunta" class="ml-20" color="primary" matTooltip="{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_TOOL_EDIT_PREG'|translate}}">
              <mat-icon>done</mat-icon>
            </button>
            <button mat-mini-fab *ngIf="datos.pregunta.typeAdd == 4" [disabled]="datos.pregunta.editarPregunta" (click)="guardaNuevaVersionPregunta(datos.pregunta)" class="ml-20" color="primary" matTooltip="{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_TOOL_NEWVERS_PREG'|translate}}">
              <mat-icon>add</mat-icon>
            </button>
          </div>
          <p *ngIf="datos.pregunta.typeAdd == 4"><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.NOTA_PREG_MOD'|translate}}</em></p>
        </ng-container>

        <mat-form-field appearance="outline" *ngIf="datos.answerType.tipoSeccion == 4" fxFlex>
          <mat-label>Escriba una descripción corta para la nueva pregunta</mat-label>
          <ng-container *ngFor="let idioma of datos.pregunta.questionLanguage;">
            <ng-container *ngIf="idioma.lang == datos.idiomaNative">
              <textarea matInput class="fwb" [(ngModel)]="idioma.descritionShort" (blur)="datos.pregunta.typeAdd != 2 && datos.pregunta.typeAdd != 6 ? datos.pregunta.typeAdd = 4 : true" [disabled]="!datos.pregunta.editarPregunta  || datos.pasoCompleto"></textarea>
            </ng-container>
          </ng-container>
        </mat-form-field>

        <!-- <div fxLayout="row" fxLayoutAlign="space-between center">
          <mat-form-field class="mt-20" fxFlex>
            <mat-label>Texto de la pregunta</mat-label>
            <mat-select [(ngModel)]="datos.pregunta.versiones[datos.pregunta.versionActual].pregunta">
              <mat-option *ngFor="let version of datos.pregunta.versiones" [value]="version.pregunta">
                {{version.pregunta}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-mini-fab (click)="editaPregunta(datos.pregunta.versionActual)" class="botEdit ml-20" matTooltip="{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_TOOL_EDIT_PREG'|translate}}">
            <mat-icon>edit</mat-icon>
          </button>
        </div> -->

        <div fxLayout="column" fxLayoutAlign="start stretch" class="mb-20" *ngIf="datos.configTemplate.audiosGlobal == true && datos.configTemplate.audios == true">
          <p class="mb-0">{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.TITULO' | translate}}</p>
          <div fxLayout="row" fxLayoutAlign="space-between center">

            <ng-container *ngFor="let idioma of datos.pregunta.questionLanguage;">
              <ng-container *ngIf="idioma.lang == datos.idiomaNative">
                <ng-container *ngIf="idioma.audio == false">
                  <p><em>{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.SIN_AUDIO' | translate}}</em></p>
                  <button mat-raised-button color="primary" (click)="DEMO_agregarAudioPregunta(idioma, 'ADD')">
                    {{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.ADD_AUDIO' | translate}}
                    <mat-icon class="ml-20">add</mat-icon>
                  </button>
                </ng-container>
                <ng-container *ngIf="idioma.audio == true">
                  <p><em>{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.CON_AUDIO' | translate}}</em></p>
                  <div fxLayout="row">
                    <button mat-mini-fab matTooltip="{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.PLAY' | translate}}" (click)="DEMO_reproducirAudioPregunta(idioma)" *ngIf="idioma.audioUrl.length == 0">
                      <mat-icon>play_arrow</mat-icon>
                    </button>
                    <audio controls *ngIf="idioma.audioUrl.length > 0">
                      <source [src]="sanitizer.bypassSecurityTrustResourceUrl(idioma.audioUrl)" type="audio/mpeg">
                        Your browser does not support the audio element.
                    </audio>
                    <button mat-mini-fab color="accent" class="ml-20" matTooltip="{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.CHANGE' | translate}}" (click)="DEMO_agregarAudioPregunta(idioma, 'CHANGE')">
                      <mat-icon>import_export</mat-icon>
                    </button>
                    <button mat-mini-fab color="primary" class="ml-20" matTooltip="{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.DELETE' | translate}}" (click)="DEMO_borrarAudioPregunta(idioma)">
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </div>

        <ng-container *ngIf="preguntaRecuperada">
          <mat-form-field class="mb-20" *ngIf="datos.pregCat">
            <mat-label>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.QUESTION_KEYWORDS'|translate}}</mat-label>
            <mat-chip-list #chipList>
              <mat-chip *ngFor="let tag of datos.pregCat.tags" [selectable]="true" [removable]="true" (removed)="borraTag(tag,2)">
                {{tag}}
                <mat-icon matChipRemove *ngIf="datos.pregCat.tags.length > 1 && !datos.pasoCompleto">cancel</mat-icon>
              </mat-chip>
              <input [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="agregaTag($event,2)">
            </mat-chip-list>
          </mat-form-field>
        </ng-container>

        <ng-container *ngIf="datos.answerType.tipoSeccion == 4">
          <ng-container *ngIf="datos.pregunta.demographicId != 0; else sinDemografico">
            <ng-container *ngFor="let demografico of datos.catalogoDemograficos;let i = index;">
              <ng-container *ngIf="demografico.demographicId == datos.pregunta.demographicId">
                <ng-container *ngFor="let langDemog of demografico.languages;let j = index;">
                  <h3 *ngIf="langDemog.lang == datos.idiomaNative">{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.TIPO_DEMOGRAFICO'|translate}}: <em>{{langDemog.key}}</em></h3>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
          <ng-template #sinDemografico>
            <h3>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.SIN_TIPO_DEMOGRAFICO'|translate}}</h3>
          </ng-template>
          <mat-divider class="mb-20"></mat-divider>
        </ng-container>

        <ng-container *ngIf="datos.configTemplate.secEspeciales == true">
          <ng-container >
            <p><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_TIP_FORM'|translate}}</em></p>
            <mat-radio-group [(ngModel)]="datos.pregunta.typeCustom">
              <div fxLayout="row" fxLayoutAlign="space-around center">
                <mat-radio-button *ngFor="let tipo of tipoEspecial" [value]="tipo.tipo">{{'CERTIFICARV3.CATALOGOS.PREG_ESPECI.' + tipo.tipo | translate}}</mat-radio-button>
              </div>
            </mat-radio-group>
          </ng-container>
          <ng-container *ngIf="datos.pregunta.typeCustom == 2">
            <mat-divider class="mt-20 mb-20"></mat-divider>
            <p><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_PREG_ESP_FLD'|translate}}</em></p>
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_PREG_ESP_HNT'|translate}}</mat-label>
              <textarea matInput class="fwb" [(ngModel)]="datos.pregunta.key"></textarea>
            </mat-form-field>
          </ng-container>
        </ng-container>

        <mat-divider class="mb-20"></mat-divider>
        <mat-card *ngIf="datos.pregunta.answerType != 2">
          <mat-card-header>
            <mat-card-subtitle>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_CARD_OPC_RESP'|translate}}</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <mat-list class="listaPreguntas" [id]="'lista' + idxSecc" cdkDropList [cdkDropListData]="datos.pregunta.answers" [cdkDropListConnectedTo]="listasPreguntas" (cdkDropListDropped)="dropPregunta($event)">
              <!-- <mat-list-item class="pregunta" [ngClass]="{'noEdit':!respuesta.banderas.editable, 'obligatoria':!respuesta.banderas.eliminable, 'obNoEdit':!respuesta.banderas.eliminable && !respuesta.banderas.editable}" cdkDrag *ngFor="let respuesta of datos.pregunta.answers; last as last; let idxResp = index;"> -->
              <ng-container *ngFor="let respuesta of datos.pregunta.answers; last as last; let idxResp = index;">
                <mat-list-item class="pregunta" cdkDrag *ngIf="respuesta.vivo == 1">
                  <div class="infoPregunta" fxLayout="row" fxLayoutAlign="space-between center">
                    <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                    <button *ngIf="!datos.pasoCompleto && datos.validationUser" mat-icon-button class="mr-20" cdkDragHandle>
                      <mat-icon>menu</mat-icon>
                    </button>
                    <div fxFlex *ngIf="preguntaRecuperada || datos.pregunta.typeAdd == 2">
                      <ng-container *ngIf="datos.pregunta.typeAdd == 0 || datos.pregunta.typeAdd == 1 || datos.pregunta.typeAdd == 4 || datos.pregunta.typeAdd == 6">
                        <ng-container *ngFor="let idioma of respuesta.answerLanguage;">
                          <ng-container *ngIf="idioma.lang == datos.idiomaNative">
                            <mat-select [value]="idioma.tag" [disabled]="datos.pasoCompleto">

                              <ng-container *ngFor="let respCat of datos.pregCat.answers; let i = index;">
                                <ng-container *ngIf="respCat.idUnique == respuesta.idUnique">
                                  <ng-container *ngFor="let respCatVers of respCat.textVersions; let j = index;">
                                    <ng-container *ngFor="let langRespCatVers of respCatVers.answerLanguage; let k = index;">
                                      <ng-container *ngIf="langRespCatVers.lang == datos.idiomaNative">
                                        <mat-option [value]="langRespCatVers.tag" (click)="cambiaVersionRespuestaTemplate(respuesta,i,j)">
                                          {{langRespCatVers.tag}}
                                          <span><em *ngIf="respuesta.answerType == 2" class="colSecEsp">{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.RESPUESTA_TIPO_OTRO'|translate}}</em></span>
                                        </mat-option>
                                      </ng-container>
                                    </ng-container>
                                  </ng-container>
                                </ng-container>
                              </ng-container>

                            </mat-select>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngIf="datos.pregunta.typeAdd == 2 || datos.pregunta.typeAdd == 5">
                        <ng-container *ngFor="let idioma of respuesta.answerLanguage;">
                          <ng-container *ngIf="idioma.lang == datos.idiomaNative">
                            {{idioma.tag}}
                            <em *ngIf="respuesta.answerType == 2" class="colSecEsp">{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.RESPUESTA_TIPO_OTRO'|translate}}</em>
                          </ng-container>
                        </ng-container>
                      </ng-container>

                    </div>
                    <button [disabled]="datos.pasoCompleto && datos.validationUser" (click)="editaRespuesta(respuesta,idxResp,2)" mat-mini-fab class="botEdit mr-10" matTooltip="{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_TOOL_EDIT_RESP'|translate}}">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button [disabled]="datos.pasoCompleto && datos.validationUser" *ngIf="datos.pregunta.answers.length > 2" (click)="borraRespuesta(idxResp)" mat-mini-fab color="primary" class="mr-10" matTooltip="{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_TOOL_DELET_RESP'|translate}}">
                      <mat-icon>delete_forever</mat-icon>
                    </button>
                    <button [disabled]="datos.pasoCompleto" *ngIf="(datos.pregunta.typeAdd != 2 && datos.pregunta.typeAdd != 5) || !revisaRespuestaOtro(datos.pregunta.answers) || respuesta.answerType == 2" mat-mini-fab color="primary" matTooltip="{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_TOOL_CONFIG_RESP'|translate}}" [matMenuTriggerFor]="menu">
                      <mat-icon>settings</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                      <mat-selection-list #shoes>
                        <ng-container *ngIf="datos.pregunta.typeAdd != 2 && datos.pregunta.typeAdd != 5">
                          <mat-list-option [selected]="respuesta.edit" (click)="$event.stopPropagation();cambiaBanderaRespuesta(respuesta,1)">{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_SLIDE_RESP_EDIT'|translate}}</mat-list-option>
                          <mat-list-option [selected]="respuesta.delete" (click)="$event.stopPropagation();cambiaBanderaRespuesta(respuesta,2)">{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_SLIDE_RESP_DELET'|translate}}</mat-list-option>
                        </ng-container>
                        <ng-container *ngIf="(!revisaRespuestaOtro(datos.pregunta.answers) || respuesta.answerType == 2) && datos.pregunta.answerType == 4">
                          <mat-list-option [selected]="respuesta.answerType == 2" (click)="$event.stopPropagation();cambiaTipoRespuesta(respuesta,idxResp,1)">{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_SLIDE_RESP_TIPO_OTRO'|translate}}</mat-list-option>
                        </ng-container>
                      </mat-selection-list>
                    </mat-menu>
                  </div>
                  <mat-divider *ngIf="!last"></mat-divider>
                </mat-list-item>
              </ng-container>

            </mat-list>
          </mat-card-content>
          <mat-card-actions>
            <div fxLayout="row" fxLayoutAlign="center center">
              <p class="pr-20">{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_AGRE_OPCI_RESP'|translate}}</p>
              <button mat-mini-fab color="primary" aria-label="agregaPreg" (click)="agregaRespuesta()" [disabled]="datos.pasoCompleto">
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </mat-card-actions>
        </mat-card>
        <mat-divider class="mt-20"></mat-divider>
        <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_CUENT_SIG_ACC_PREG'|translate}}</p>
        <div fxLayout="row" fxLayoutAlign="space-between stretch">
          <mat-card fxFlex="47" class="mat-elevation-z3">
            <mat-card-header>
              <mat-card-subtitle>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_CATA_MAES'|translate}}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <div fxLayout="column" fxLayoutAlign="start center">

                <p class="mr-20" *ngIf="datos.pregunta.typeAdd == 4 && datos.pregunta.idUnique < 99999"><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_DETEC_CAMB_TEX_PREG'|translate}}</em> </p>
                <p class="mr-20" *ngIf="datos.pregunta.typeAdd == 5 && datos.pregunta.idUnique < 99999"><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_DETEC_CAMB_TEX_RESP'|translate}}</em> </p>
                <p class="mr-20" *ngIf="(datos.pregunta.typeAdd == 2 || datos.pregunta.typeAdd == 3) && datos.pregunta.idUnique >= 99999"><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_PREG_NO_GUAR_CATA'|translate}}</em> </p>
                <mat-list>
                  <mat-list-item *ngIf="(datos.pregunta.typeAdd == 2 || datos.pregunta.typeAdd == 3) && datos.pregunta.idUnique >= 99999">
                    <div fxLayout="row" class="w100" fxLayoutAlign="space-between center">
                      <p class="fz14 mr-20">{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_GUAR_PREG'|translate}}</p>
                      <button mat-mini-fab color="accent" (click)="guardaNuevaPreguntaMC(datos.pregunta)">
                        <mat-icon>save</mat-icon>
                      </button>
                    </div>
                    <mat-divider></mat-divider>
                  </mat-list-item>
                  <mat-list-item *ngIf="(datos.pregunta.typeAdd == 4 || datos.pregunta.typeAdd == 5) && datos.pregunta.idUnique < 99999">
                    <div fxLayout="row" class="w100" fxLayoutAlign="space-between center">
                      <p class="fz14 mr-20">{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_GUAR_CAMB'|translate}}</p>
                      <button mat-mini-fab color="accent" (click)="actualizaPreguntaMC(datos.pregunta)">
                        <mat-icon>save</mat-icon>
                      </button>
                    </div>
                    <mat-divider></mat-divider>
                  </mat-list-item>
                  <!-- <mat-list-item *ngIf="datos.pregunta.idUnique < 99999 && datos.validationUser">
                    <div fxLayout="row" class="w100" fxLayoutAlign="space-between center">
                      <p class="fz14 mr-20">{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_DELET_PREG'|translate}}</p>
                      <button mat-mini-fab color="accent" (click)="borraPreguntaMC(datos.pregunta)">
                        <mat-icon>delete_forever</mat-icon>
                      </button>
                    </div>
                  </mat-list-item> -->
                </mat-list>

              </div>
            </mat-card-content>
          </mat-card>
          <mat-card fxFlex="47" class="mat-elevation-z3">
            <mat-card-header>
              <mat-card-subtitle>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_CARD_PLAN'|translate}}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <div fxLayout="column" fxLayoutAlign="space-between center">
                <mat-slide-toggle [disabled]="datos.pasoCompleto" [(ngModel)]="datos.pregunta.edit" (change)="cambiaBanderaPregunta($event,datos.pregunta)" [labelPosition]="'before'" class="mb-20">{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_SLIDE_PREG_EDIT'|translate}}</mat-slide-toggle>
                <mat-slide-toggle [disabled]="datos.pasoCompleto" [(ngModel)]="datos.pregunta.delete" (change)="cambiaBanderaPregunta($event,datos.pregunta)" [labelPosition]="'before'" class="mb-20">{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_SLIDE_PREG_DELET'|translate}}</mat-slide-toggle>
                <mat-slide-toggle [disabled]="datos.pasoCompleto" [(ngModel)]="datos.pregunta.required" (change)="cambiaBanderaPregunta($event,datos.pregunta,true)" [labelPosition]="'before'" class="mb-20">{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_SLIDE_PREG_REQUI'|translate}}</mat-slide-toggle>
              </div>
            </mat-card-content>
          </mat-card>

        </div>
      </ng-container>
    </div>
  </mat-dialog-content>
  <button mat-raised-button color="accent" class="mt-20" (click)="salir()">
    {{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.BTN_REGRES'|translate}}
    <mat-icon class="ml-20">arrow_back</mat-icon>
  </button>
</ng-container>

<ng-container *ngIf="datos.opcion == 'preguntaOpc'">
  <h2 mat-dialog-title>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_NEW_PREG'|translate}}</h2>
  <mat-dialog-content class="mat-typography">
    <div fxLayout="column" fxLayoutAlign="start stretch">
      <p *ngIf="datos.tipoSeccion == 1 || datos.tipoSeccion == 2 || datos.tipoSeccion == 3"><em>{{'CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEXT_AGRE_NEW_PREG'|translate}}</em></p>
      <p *ngIf="datos.tipoSeccion == 4"><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_ESCR_TEXT_AGRE_OPCI_RESP'|translate}}</em></p>
      <p *ngIf="datos.tipoSeccion == 5 || datos.tipoSeccion == 7"><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_ESCR_TEXT_SELEC_TIP_PRE'|translate}}</em></p>
      <mat-form-field appearance="outline" fxFlex>
        <mat-label>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_LAB_TEX_PREG'|translate}}</mat-label>
        <textarea matInput class="fwb" [(ngModel)]="datosPreguntaNueva.pregunta"></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline" *ngIf="datos.tipoSeccion == 4" fxFlex>
        <mat-label>Escriba una descripción corta para la nueva pregunta</mat-label>
        <textarea matInput class="fwb" [(ngModel)]="datosPreguntaNueva.descripcion"></textarea>
      </mat-form-field>

      <ng-container *ngIf="!datos.modoEmpresa">
        <p><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_CLAVE_DEMOGR'|translate}} <b>#</b> {{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_CLAVE_DEMOGR1'|translate}}</em></p>
        <mat-form-field appearance="outline">
          <mat-label>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_PALA_CLAVE_DEMOGR'|translate}}</mat-label>
          <mat-chip-list #chipList>
            <mat-chip *ngFor="let tag of datosPreguntaNueva.tags" [selectable]="true" [removable]="true" (removed)="borraTag(tag,1)">
              {{tag}}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            <input [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="agregaTag($event,1)">
          </mat-chip-list>
        </mat-form-field>
        <p class="mb-20"><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_CLAVE_DEMOGR2'|translate}}</em></p>
      </ng-container>

      <ng-container *ngIf="!datos.modoEmpresa">
        <p *ngIf="datos.tipoSeccion == 4">{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_SELE_TIPO_DEMOGR'|translate}}</p>
        <mat-form-field *ngIf="datos.tipoSeccion == 4">
          <mat-label>Elija un tipo de la lista</mat-label>
          <!-- <mat-select (selectionChange)="eligePreguntaCat($event.value)" [disabled]="arrayPreguntas.length >= datos.nuevasRestantes"> -->
            <mat-select [(ngModel)]="datosPreguntaNueva.demografico">
              <ng-container *ngFor="let demografico of datos.catalogoDemograficos;let i = index;">
                <ng-container *ngFor="let langDemog of demografico.languages;let j = index;">
                  <mat-option *ngIf="langDemog.lang == datos.idiomaNativo && langDemog.key != ''" [value]="demografico.demographicId">
                    {{langDemog.key}}
                  </mat-option>
                </ng-container>
              </ng-container>
            </mat-select>
          </mat-form-field>

      </ng-container>

      <mat-divider class="mb-20"></mat-divider>
      <ng-container *ngIf="datos.tipoSeccion == 1 || datos.tipoSeccion == 3 || datos.tipoSeccion == 4 || datos.tipoSeccion == 7">
        <p><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_TIP_PREG'|translate}}</em></p>
        <mat-radio-group [(ngModel)]="datosPreguntaNueva.tipo">
          <div fxLayout="row" fxLayoutAlign="space-around center">
            <ng-container *ngFor="let tipo of tiposPreguntas">
              <mat-radio-button *ngIf="tipo.seccion.includes(datos.tipoSeccion)" [value]="tipo.tipo">{{'CERTIFICARV3.CATALOGOS.PREGUNTAS.' + tipo.tipo | translate}}</mat-radio-button>
            </ng-container>
          </div>
        </mat-radio-group>
      </ng-container>
      <ng-container *ngIf="datosPreguntaNueva.tipo == 2">
        <mat-divider class="mt-20 mb-20"></mat-divider>
        <p><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_TIP_RESP'|translate}}</em></p>
        <mat-radio-group [(ngModel)]="datosPreguntaNueva.tipoAbierta">
          <div fxLayout="row" fxLayoutAlign="space-around center">
            <mat-radio-button *ngFor="let tipo of tiposAbiertas" [value]="tipo.tipo">{{'CERTIFICARV3.CATALOGOS.ABIERTAS.' + tipo.tipo | translate}}</mat-radio-button>
          </div>
        </mat-radio-group>
      </ng-container>
      <mat-card *ngIf="(datos.tipoSeccion == 1 || datos.tipoSeccion == 3 || datos.tipoSeccion == 4 || datos.tipoSeccion == 7) && (datosPreguntaNueva.tipo == 1 || datosPreguntaNueva.tipo == 4 || datosPreguntaNueva.tipo == 6)">
        <mat-card-header>
          <mat-card-subtitle>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_CARD_OPC_RESP'|translate}}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <mat-list class="listaPreguntas" [id]="'lista' + idxSecc" cdkDropList [cdkDropListData]="datosPreguntaNueva.respuestas" [cdkDropListConnectedTo]="listasPreguntas" (cdkDropListDropped)="dropPregunta($event)">
            <!-- <mat-list-item class="pregunta" [ngClass]="{'noEdit':!respuesta.banderas.editable, 'obligatoria':!respuesta.banderas.eliminable, 'obNoEdit':!respuesta.banderas.eliminable && !respuesta.banderas.editable}" cdkDrag *ngFor="let respuesta of datosPreguntaNueva.respuestas; last as last; let idxResp = index;"> -->
            <mat-list-item class="pregunta" cdkDrag *ngFor="let respuesta of datosPreguntaNueva.respuestas; last as last; let idxResp = index;">
              <div class="infoPregunta" fxLayout="row" fxLayoutAlign="space-between center">
                <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                <button mat-icon-button class="mr-20" cdkDragHandle>
                  <mat-icon>menu</mat-icon>
                </button>
                <div fxFlex>
                  {{respuesta.versiones[respuesta.versionActual].respuesta}}
                </div>
                <div class="accionesPregunta">
                  <button *ngIf="respuesta.banderas.editable" (click)="editaRespuesta(respuesta.versionActual,idxResp,1,true)" mat-mini-fab class="botEdit mr-10" matTooltip="{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_TOOL_EDIT_RESP'|translate}}">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button *ngIf="respuesta.banderas.eliminable && datosPreguntaNueva.respuestas.length > 2" (click)="borraRespuesta(idxResp,true)" mat-mini-fab color="primary" class="mr-20" matTooltip="{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.MAT_TOOL_DELET_RESP'|translate}}">
                    <mat-icon>delete_forever</mat-icon>
                  </button>
                </div>
              </div>
              <mat-divider *ngIf="!last"></mat-divider>
            </mat-list-item>
          </mat-list>
        </mat-card-content>
        <mat-card-actions>
          <div fxLayout="row" fxLayoutAlign="center center">
            <p class="pr-20">{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_AGRE_OPCI_RESP'|translate}}</p>
            <button mat-mini-fab color="primary" aria-label="agregaPreg" (click)="agregaRespuesta(true)">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </mat-card-actions>
      </mat-card>
      <ng-container *ngIf="datos.configTemplate.secEspeciales == true">
        <ng-container >
          <mat-divider class="mt-20 mb-20"></mat-divider>
          <p><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_TIP_FORM'|translate}}</em></p>
          <mat-radio-group [(ngModel)]="datosPreguntaNueva.typeCustom">
            <div fxLayout="row" fxLayoutAlign="space-around center">
              <mat-radio-button *ngFor="let tipo of tipoEspecial" [value]="tipo.tipo">{{'CERTIFICARV3.CATALOGOS.PREG_ESPECI.' + tipo.tipo | translate}}</mat-radio-button>
            </div>
          </mat-radio-group>
        </ng-container>
        <ng-container *ngIf="datosPreguntaNueva.typeCustom == 2">
          <mat-divider class="mt-20 mb-20"></mat-divider>
          <p><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_PREG_ESP_FLD'|translate}}</em></p>
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_PREG_ESP_HNT'|translate}}</mat-label>
            <textarea matInput class="fwb" [(ngModel)]="datosPreguntaNueva.key"></textarea>
          </mat-form-field>
        </ng-container>
      </ng-container>
    </div>
  </mat-dialog-content>
  <button mat-raised-button color="accent" class="mt-20" (click)="salirPregNueva(1)">
    {{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.BTN_CANCELAR'|translate}}
    <mat-icon class="ml-20">close</mat-icon>
  </button>
  <button mat-raised-button color="primary" class="ml-20 mt-20" (click)="salirPregNueva(2)">
    {{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.BTN_CONTINU'|translate}}
    <mat-icon class="ml-20">check</mat-icon>
  </button>
</ng-container>

<ng-container *ngIf="datos.opcion == 'preguntaForall'">
  <h2 mat-dialog-title>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_NEW_PRAC_4ALL'|translate}}</h2>
  <mat-dialog-content class="mat-typography">
    <div fxLayout="column" fxLayoutAlign="start stretch">
      <p><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_INST_NOMBRE_DESC_4ALL'|translate}}</em></p>
      <mat-form-field appearance="outline" fxFlex>
        <mat-label>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_LABE_NOMBRE'|translate}}</mat-label>
        <textarea matInput class="fwb" [(ngModel)]="datosPracticaNueva.practica"></textarea>
      </mat-form-field>
      <mat-form-field appearance="outline" class="mt-20" fxFlex>
        <mat-label>{{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_LABE_DESC'|translate}}</mat-label>
        <textarea matInput class="fwb" [(ngModel)]="datosPracticaNueva.descripcion"></textarea>
      </mat-form-field>
      <mat-divider class="mb-20"></mat-divider>
    </div>
  </mat-dialog-content>
  <button mat-raised-button color="accent" class="mt-20" (click)="salirFANueva(1)">
    {{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.BTN_CANCELAR'|translate}}
    <mat-icon class="ml-20">close</mat-icon>
  </button>
  <button mat-raised-button color="primary" class="ml-20 mt-20" (click)="salirFANueva(2)">
    {{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.BTN_CONTINU'|translate}}
    <mat-icon class="ml-20">check</mat-icon>
  </button>
</ng-container>
